"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var mobx_1 = require("mobx");
var AngularSyncStore_1 = __importStar(require("Utils/AngularSyncStore"));
var DefaultLabelFields_1 = __importDefault(require("./DefaultLabelFields"));
var QuoteLabelStore = (function (_super) {
    __extends(QuoteLabelStore, _super);
    function QuoteLabelStore(initialData, services) {
        var _this = _super.call(this, initialData.labels, services) || this;
        _this.getLabel = function (labelSetId, label) {
            return (0, mobx_1.computed)(function () { var _a; return ((_a = _this.labels.find(function (labelSet) { return labelSet.id === labelSetId; })) === null || _a === void 0 ? void 0 : _a.labels[label]) || DefaultLabelFields_1.default[label]; }).get();
        };
        _this.onAngularUpdated = function (newData) {
            _this.labels = newData;
        };
        _this.onAngularUpdated(initialData.labels);
        return _this;
    }
    Object.defineProperty(QuoteLabelStore.prototype, "dataForAngular", {
        get: function () {
            return this.labels;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], QuoteLabelStore.prototype, "labels", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteLabelStore.prototype, "onAngularUpdated", void 0);
    QuoteLabelStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("accountQuoteSettings")),
        __param(1, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __metadata("design:paramtypes", [Object, typeof (_a = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _a : Object])
    ], QuoteLabelStore);
    return QuoteLabelStore;
}(AngularSyncStore_1.default));
exports.default = QuoteLabelStore;
